import { cn } from "@/shared/lib/cn";

/* One row on the charcoal rail. The current one sits on a raised plate with a sage bar on its
   start edge and its icon in sage; the rest stay quiet until hovered. */
const ROW =
  "group/row relative flex h-9 items-center gap-3 rounded-xl px-1.5 text-[14.5px] transition-[background-color,color] duration-150 outline-none focus-visible:ring-2 focus-visible:ring-rail-accent/60";

export const sidebarRowClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    ROW,
    isActive
      ? "bg-rail-raised font-semibold text-rail-ink shadow-[inset_0_1px_0_rgb(255_255_255/0.05)] before:absolute before:inset-y-2.5 before:-start-2.5 before:w-1 before:rounded-full before:bg-rail-accent"
      : "font-medium text-rail-ink-muted hover:bg-rail-hover hover:text-rail-ink",
  );

/** The square behind a row's icon: sage on the current row, quiet elsewhere. */
export const sidebarIconTileClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    "grid size-7.5 shrink-0 place-items-center rounded-lg transition-colors [&_svg]:size-[18px]",
    isActive
      ? "bg-rail-accent/15 text-rail-accent"
      : "text-rail-ink-subtle group-hover/row:text-rail-ink-muted",
  );
